import {required, ValidationResult, Validator} from '@/types/validation/ValidationResult';
import {AuthenticationRequest} from '@/types/authentication/Authentication';

export class SignInChecker {
  result: ValidationResult;

  constructor(result: AuthenticationRequest) {
    const checker = new ValidationResult(SignInValidator);
    checker.validate(result);
    this.result = checker;
  }

  get hasErrors(): boolean {
    return this.result.hasErrors;
  }

  get getMessages(): string[] {
    return this.result.getMessages();
  }
}

export const SignInValidator: Validator[] = [
  {
    name: 'assessorNumber',
    constraints: [
      {method: required, message: '査定士番号を入力してください'},
      {method: assessorNumberFormat, message: '査定士番号は8桁を入力ください'},
    ],
  },
  {
    name: 'officeCode',
    constraints: [
      {method: required, message: '支所を選択してください'},
    ],
  },
  {
    name: 'password',
    constraints: [
      {method: required, message: 'パスワードを入力してください'},
    ],
  },
];

export function assessorNumberFormat(value: string): boolean {
  if (!value) {
    return true;
  }

  // 特殊査定士（JAAI-XX形式）7桁
  if (value.match(/JAAI-/)) {
    return value.length === 7;
  }

  // 通常形式: 8桁（支所2桁 + 査定士番号6桁）
  // 2026/06/01 SC,PBD用のアカウント許容するための改修
  if (value.length === 8) {
    const assessorPart = value.substring(2); // 末尾6桁を抽出
    // チェックを向上させる（数値6桁 OR 英字1桁+数値5桁）
    return /^[0-9]{6}$/.test(assessorPart) ||
           /^[A-Z][0-9]{5}$/.test(assessorPart) ||
           /^0000[a-zA-Z]{2}$/.test(assessorPart);
  }

  return false;
}
